import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface HelpSearchProps {
  value: string;
  onChange: (value: string) => void;
}

const HelpSearch: React.FC<HelpSearchProps> = ({ value, onChange }) => (
  <TextField
    fullWidth
    placeholder="Search help topics, pages, actions, or terms..."
    value={value}
    onChange={(e) => onChange(e.target.value)}
    aria-label="Search help topics"
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 20 }} />
          </InputAdornment>
        ),
        sx: { height: 48, minHeight: 48, borderRadius: '8px', fontSize: '0.9rem' },
      },
    }}
    sx={{ maxWidth: 640 }}
  />
);

export default HelpSearch;
